import axios from "axios";
import { API_BASE_URL } from '../../config';

// Create an Axios instance
const axiosApi = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

// ✅ Request Interceptor — Attach Token
axiosApi.interceptors.request.use(
  (config) => {
    const token = sessionStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// ✅ Response Interceptor — Global Error Handling
axiosApi.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response) {
      const { status, data } = error.response;

      if (status === 401) {
        // Store error message so ErrorPage can show it
        sessionStorage.setItem("global_error", data?.message || "Unauthorized");
        // Optionally clear token
        sessionStorage.removeItem("token");
        // Redirect to error or login
        window.location.href = "/error";
      }
 // ----- 403 (Business Exception) -----
      if (status === 403) {
        const message =
    data?.message ||
    data ||
    "Action not allowed (403).";

  // Emit global error message instead of alert
  window.dispatchEvent(new CustomEvent("GLOBAL_ERROR", {
  detail: message
}));
      }
     
    }
    return Promise.reject(error);
  }
);

export default axiosApi;
